import { useSupabaseCallback } from "../../server/supabase/hooks";
import { SupabaseBrandKitService } from "./server/brand-kit-service";
import type { BrandInfoSelected } from "./types";
import { sortLogos } from "./utils";

export const useGetBrandingBarDefaults = (): (() => Promise<
  Pick<BrandInfoSelected, "color" | "logo"> | undefined
>) => {
  return useSupabaseCallback(async ({ supabase }) => {
    const { data } = await new SupabaseBrandKitService(supabase).maybeGet();

    if (!data) return;

    const logos = sortLogos(data.logos ?? []);
    const colors = data.colors ?? [];

    return {
      logo: logos.find((logo) => logo.is_default_logo),
      color: colors.find((color) => color.is_default_primary_color),
    };
  }, []);
};
